import React, { useCallback } from 'react'
import { useLocalization } from '@/hooks/localization'
import { useReduxState } from '@/hooks/reduxState'
import { Button } from 'reactstrap'
import { useDispatch } from '@/hooks/dispatch'
import { dialogTypes } from '@/dialogs'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { actionCreators } from '@/store/checkingRules'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import Icon from '@/components/Icon'
import context from '@/context'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody, WhiteBox } from '@/components/Layout'
import {
  BsrsGrid,
  EnumFilterCell,
  EnumCell,
  commandColumnProps,
  BooleanColumn
} from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import Resx from '@/components/Resx'
import { checkingRuleSeverity } from '@/enums/checkingRuleSeverity'

const CheckingRuleList = (props) => {
  const { localize } = useLocalization()
  const [openDialog, deleteRule] = useDispatch([ dialogActions.openDialog, actionCreators.delete ])
  const onEdit = useCallback((dataItem) => {
    openDialog({
      dialogType: dialogTypes.editCheckingRule,
      title: 'Reporting.EditCheckingRule',
      id: dataItem.id
    })
  }, [openDialog])
  const onDelete = useCallback((item) => { deleteRule(item.id) }, [deleteRule])
  const { checkingRules } = useReduxState(state => ({ checkingRules: state.checkingRules }))
  const isGranted = usePermissionChecker()
  const enumName = checkingRuleSeverity.enumName
  const canManage = isGranted('CanManageCheckingRules')
  return (
    <Main>
      <MainTop>
        <MainTopTitle><Resx name='Reporting.CheckingRules' /></MainTopTitle>
        <MainTopLeft>
          {canManage && <Button size='sm' color='primary' onClick={e => onEdit({ id: 0 })}>
            <Icon name='plus' /> <span><Resx name='Reporting.AddCheckingRule' /></span>
          </Button>}
        </MainTopLeft>
      </MainTop>
      <MainBody transparent>
        <WhiteBox>
          <BsrsGrid
            persistenceId={'administration-checking-rules'}
            dataSource={context.api.checkingRuleService.getTableData}
            lastReloadedAt={checkingRules.gridKey}
            filterable>
            <Column field='id' title={localize('Common.Id')} filter='numeric' editable={false} />
            <Column field='expression' title={localize('Reporting.Expression')} editable={false} />
            <Column
              field='severity'
              title={localize('Reporting.Severity')}
              cell={EnumCell({ localize, enumName })}
              filterCell={EnumFilterCell({ localize, enumName }, checkingRuleSeverity.values)}
              enumName={enumName}
              editable={false} />
            {BooleanColumn({ field: 'hasEnglishMessage', title: localize('Reporting.HasEnglishMessage'), editable: true })}
            {BooleanColumn({ field: 'hasArabicMessage', title: localize('Reporting.HasArabicMessage'), editable: true })}
            <Column {...commandColumnProps({ onDetailClick: onEdit, deleteAction: canManage ? onDelete : null })} />
          </BsrsGrid>
        </WhiteBox>
      </MainBody>
    </Main>
  )
}

export {
  CheckingRuleList
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/checking-rules/list.js